import React from 'react';
import { footerColumns } from '../data/navigation';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-343" data-mp="3gfsmscqd8umz">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.2fr_1.2fr_1.1fr_1fr_1fr] gap-12 lg:gap-8" data-id="element-344" data-mp="32oe11y52qfc8">
        <div className="sm:col-span-2 lg:col-span-1 lg:pr-8" data-id="element-345" data-mp="36q90ex3g2ind">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-346" data-mp="3ueil1vox90cx" />
          <p className="text-sm leading-relaxed" data-id="element-347" data-mp="3ldkdx4j6scq4">Building intelligence in the world.</p>
        </div>

        {footerColumns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-348" data-mp="29z6t68jqcdeb">
            <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm whitespace-nowrap" data-id="element-349" data-mp="29xvq6ay3z9o9">
              {column.heading}
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-350" data-mp="3l8qxu8j60rtk">
              {column.links.map(link => <li key={`${column.heading}-${link.label}`} className={link.nested ? 'pl-3' : ''} data-id="element-351" data-mp="3gb8vx23kfcv2">
                  <a href={link.href} className="hover:text-white transition-colors duration-150" data-id="element-352" data-mp="3v7zw3dl2cslq">
                    {link.nested && <span aria-hidden="true" className="text-white/40 mr-2" data-id="element-353" data-mp="3q7u0xnfl4nyw">↳</span>}
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-354" data-mp="31uplihsodpw">
        <p data-id="element-355" data-mp="ct78vlpj1vkb">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-356" data-mp="qti04pur1c60">
          <a href="/privacy" className="hover:text-white transition-colors duration-150" data-id="element-357" data-mp="qujilfe3h0xr">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors duration-150" data-id="element-358" data-mp="mptp1x6wryg0">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}